import React from 'react'

const FrontUploadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
        <path
            d="M33.1498 24.7499V42.8999H27.1498V24.7499H21.1498L30.1498 8.9999L39.1498 24.7499H33.1498Z"
            fill="#0562D2"
        />
        <path
            d="M48.4499 42.2998V48.2998H12.1499V42.2998H8.99988V51.2998H51.2999V42.2998H48.4499V42.2998Z"
            fill="#0562D2"
        />
    </svg>
)

export default FrontUploadIcon
